import { call } from '@advanza/api'
import { Checkbox } from '@advanza/input'
import { Button, Divider } from '@advanza/ui'
import { DIALOG_BACKDROP_FADE } from '@trustoo/components/modal/constants/dialogPresets'
import Dialog from '@trustoo/components/modal/Dialog'
import AutoRow from 'components/misc/AutoRow'
import { useAppDispatch } from 'hooks/hooks'
import { useState } from 'react'

const INVOICE_TYPE_CREDIT_LIMIT_REACHED = 'credit_limit_reached'

interface Props {
    providerId: number
}
const GenerateInterimInvoiceButton = ({ providerId }: Props) => {
    const [loading, setLoading] = useState(false)
    const [response, setResponse] = useState<object | null>(null)
    const [open, setOpen] = useState(false)
    const [isCreditLimitReached, setIsCreditLimitReached] = useState(false)
    const dispatch = useAppDispatch()

    const generate = async () => {
        setLoading(true)
        try {
            const response = await call(`office/invoices/generate-interim-invoice/${providerId}`, {
                json: {
                    dateEnd: new Date().toISOString(),
                    dateStart: new Date(
                        new Date().getFullYear(),
                        new Date().getMonth(),
                        1,
                    ).toISOString(),
                    invoiceType: isCreditLimitReached ? INVOICE_TYPE_CREDIT_LIMIT_REACHED : null,
                },
            })
            setResponse(response)
            dispatch({ type: 'INVALIDATE_INVOICES' })
        } catch (e) {
            setResponse({ error: e })
        }
        setLoading(false)
    }

    return (
        <div>
            <Button appearance="secondary" onClick={() => setOpen(true)}>
                Generate interim invoice
            </Button>
            <Dialog.Root
                open={open}
                onClose={() => setOpen(false)}
                className={`md:w-[500px] md:max-w-full ${DIALOG_BACKDROP_FADE}`}>
                <Dialog.CloseButton onClick={() => setOpen(false)} aria-label="Close" />
                <div className="p-4">
                    <h3>Are you sure?</h3>
                    <Divider m />
                    <Checkbox
                        value={isCreditLimitReached}
                        onChange={() => setIsCreditLimitReached(!isCreditLimitReached)}
                        title="Credit limit reached"
                    />
                    <Divider m />
                    <AutoRow>
                        <Button appearance="primary" onClick={generate}>
                            {loading ? 'Generating...' : 'Continue generate interim invoice'}
                        </Button>
                        <Button appearance="secondary" onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                    </AutoRow>
                    {response && <pre>{JSON.stringify({ response }, null, 2)}</pre>}
                </div>
            </Dialog.Root>
        </div>
    )
}

export default GenerateInterimInvoiceButton
